/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Solution_LabelInputs */

const en_case_history_solution_label = /** @type {(inputs: Case_History_Solution_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solution`)
};

const pt_br2_case_history_solution_label = /** @type {(inputs: Case_History_Solution_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solução`)
};

/**
* | output |
* | --- |
* | "Solution" |
*
* @param {Case_History_Solution_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_solution_label = /** @type {((inputs?: Case_History_Solution_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Solution_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_solution_label(inputs)
	return pt_br2_case_history_solution_label(inputs)
});